/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserDtoHouseholdInfoNycData { 
    syncStatus: UserDtoHouseholdInfoNycData.SyncStatusEnum;
    nycId?: number;
}
export namespace UserDtoHouseholdInfoNycData {
    export const SyncStatusEnum = {
        synced: 'synced'
    } as const;
    export type SyncStatusEnum = typeof SyncStatusEnum[keyof typeof SyncStatusEnum];
}


